module.exports = __webpack_public_path__ + "static/img/logo_52.939ffb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_52.png
// module id = 5xhy
// module chunks = 1